/**
 * abilityVfxAssassinMeshes — Shape dispatch for SPY-610 assassin wave (OCP).
 */
import {
  buildRazorShuriken,
  buildLivingShadow,
  buildShadowSlash,
  buildDeathMark
} from './abilityVfxZed.js';
import {
  buildBouncingBlade,
  buildPreparation,
  buildShunpo,
  buildDeathLotus
} from './abilityVfxKatarina.js';

const ASSASSIN_SHAPE_BUILDERS = {
  razor_shuriken: buildRazorShuriken,
  living_shadow: buildLivingShadow,
  shadow_slash: buildShadowSlash,
  death_mark: buildDeathMark,
  bouncing_blade: buildBouncingBlade,
  preparation: buildPreparation,
  shunpo: buildShunpo,
  death_lotus: buildDeathLotus
};

/** @returns {object|null} */
export function buildAssassinAbilityMesh(THREE, spec) {
  const build = ASSASSIN_SHAPE_BUILDERS[spec?.shape];
  return build ? build(THREE, spec) : null;
}
